<template>
    <div class="header">
        <transition name="fade">
            <div class="darkness" v-if="menuIsOpen" @click="menuTrigger"></div>
        </transition>
        <div class="top">
            <div class="bars-icon icon">
                <font-awesome-icon
                    v-if="!menuIsOpen"
                    @click="menuTrigger"
                    icon="bars"
                    size="lg"
                    class="orange"
                    key="menu"
                />
            </div>
            <div class="logo-wrapper">
                <div class="logo"></div>
            </div>
            <div
                @click="layoutChange()"
                :class="['layout-trigger-mobile', 'icon', this.layoutClass]"
            ></div>
        </div>
        <transition name="slide-in">
            <div class="nav-wrapper" v-if="menuIsOpen">
                <div class="wrap-nav-scroll">
                    <v-bar wrapper="v-bar-wrapper">
                        <div class="nav">
                            <div class="caption">
                                <div class="icon-chevron-left icon" @click="menuTrigger"></div>
                                <div class="logo-wrapper">
                                    <div class="logo"></div>
                                </div>
                            </div>
                            <navigation />
                            <div class="account">
                                <div class="avatar">
                                    <font-awesome-icon icon="user-circle" class="grey2 avatar-icon" />
                                </div>
                                <div class="info">
                                    <span class="name">
                                        {{ name }}
                                    </span>
                                    <a class="logout" href="#" @click="logout">
                                        выход
                                    </a>
                                </div>
                            </div>
                            <div class="disclaimer">
                                <p>
                                    © «Оконные технологии» – изготовление, установка и продажа
                                    пластиковых окон в Москве и Московской области, 2019
                                </p>
                            </div>
                        </div>
                    </v-bar>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Navigation from './Navigation';
import Header from './Header';
import { eventBus } from '@/common/eventBus';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import VBar from 'v-bar';

library.add(faBars, faChevronLeft);

export default {
    name: 'HeaderMobile',
    components: {
        navigation: Navigation,
        VBar
    },
    extends: Header,
    data() {
        return {
            menuIsOpen: false,
            layoutIsMobile: null
        };
    },
    methods: {
        menuTrigger() {
            this.menuIsOpen = !this.menuIsOpen;
        }
    },
    mounted() {
        eventBus.$on('close-mobile-menu', () => {
            this.menuTrigger();
        });
    }
};
</script>
